import {
    GET_ALL_JOBS,
    GET_ALL_CHILD_JOBS,
    FETCH_ALL_JOBS,
    SINGLE_SELECT_JOB,
    FETCH_ALL_NOTIFICATIONS,
    GET_ALL_NOTIFICATIONS,
    REQUESTED_BY,
    GET_MONITORING,
    SELECT_SERVICES_DATA,
    SELECT_RELOCATION_DATA,
    SELECT_CHANGE_EQUIPMENT,
    SELECT_REMOVAL_ORDER,
    SELECT_INSTALLATION_BOSSUNIT,
    SELECT_INSTALLATION_XSERIES,
    SET_JOB_STATUS,
    SELECT_INSTALLATION_TYPE,
    SET_JOB_UPLOAD_PHOTOS,
    SEND_SMS,
    SEND_SMS_DATA,
    TOTAL_SERVICES,
    SELECT_INSTALLATION_TIMELAPSE,
    FETCH_ALL_MEMO,
    CALL_MEMO,
    CALL_SERVICES,
    CALL_MONITORING,
    PRINT_OPTION,
    UNSAVED_MODAL_CALL,
    ASSIGN_TECHNICIAN_MODAL,
    CALL_SERVICES_OF_JOBS
} from './actions';

export default function reducer(
    state = {
        AllJobs: [],
        AllChildsJobs: [],
        AllNotifications: [],
        totalServices: [],
        allMemo: [],
        fetchAllJobsData: true,
        fetchNotification: true,
        triggerSendSMS: false,
        callMemo: true,
        isPrintOption: false,
        isUnsavedOption: false,
        callServices: true,
        callMonitoringData: true,
        isTechnicianAssign: false,
        isCallService: false,
        singleSelectJob: {},
        RequestedBy: {},
        Monitoring: {},
        ServicesData: {},
        relocationData: {},
        changeOfEquipmentData: {},
        removalOrderData: {},
        installationBossUnitData: {},
        installationXseriesData: {},
        installationTimeLapseData: {},
        SMSData: {},
        jobStatus: '',
        selectInstallationType: null,
        uploadJobPhotos: []
    },
    action
) {
    switch (action.type) {
        case GET_ALL_JOBS:
            return {
                ...state,
                AllJobs: action.payload.data,
            };
        case GET_ALL_CHILD_JOBS:
            return {
                ...state,
                AllChildsJobs: action.payload.data,
            };
        case GET_ALL_NOTIFICATIONS:
            return {
                ...state,
                AllNotifications: action.payload.data,
            };
        case FETCH_ALL_JOBS:
            return {
                ...state,
                fetchAllJobsData: action.payload.data,
            };
        case FETCH_ALL_NOTIFICATIONS:
            return {
                ...state,
                fetchNotification: action.payload.data,
            };
        case SINGLE_SELECT_JOB:
            return {
                ...state,
                singleSelectJob: action.payload.data,
            };
        case REQUESTED_BY:
            return {
                ...state,
                RequestedBy: action.payload.data,
            };
        case GET_MONITORING:
            return {
                ...state,
                Monitoring: action.payload.data,
            };
        case SELECT_SERVICES_DATA:
            return {
                ...state,
                ServicesData: action.payload.data,
            };
        case SELECT_RELOCATION_DATA:
            return {
                ...state,
                relocationData: action.payload.data,
            };
        case SELECT_CHANGE_EQUIPMENT:
            return {
                ...state,
                changeOfEquipmentData: action.payload.data,
            };
        case SELECT_REMOVAL_ORDER:
            return {
                ...state,
                removalOrderData: action.payload.data,
            };
        case SELECT_INSTALLATION_BOSSUNIT:
            return {
                ...state,
                installationBossUnitData: action.payload.data,
            };
        case SELECT_INSTALLATION_XSERIES:
            return {
                ...state,
                installationXseriesData: action.payload.data,
            };
        case SELECT_INSTALLATION_TIMELAPSE:
            return {
                ...state,
                installationTimeLapseData: action.payload.data,
            };
        case SET_JOB_STATUS:
            return {
                ...state,
                jobStatus: action.payload.data,
            };
        case SELECT_INSTALLATION_TYPE:
            return {
                ...state,
                selectInstallationType: action.payload.data,
            };
        case SET_JOB_UPLOAD_PHOTOS:
            return {
                ...state,
                uploadJobPhotos: action.payload.data,
            };
        case SEND_SMS:
            return {
                ...state,
                triggerSendSMS: action.payload.data,
            };
        case SEND_SMS_DATA:
            return {
                ...state,
                SMSData: action.payload.data,
            };
        case TOTAL_SERVICES:
            return {
                ...state,
                totalServices: action.payload.data,
            };
        case FETCH_ALL_MEMO:
            return {
                ...state,
                allMemo: action.payload.data,
            };
        case CALL_MEMO:
            return {
                ...state,
                callMemo: action.payload.data,
            };
        case CALL_SERVICES:
            return {
                ...state,
                callServices: action.payload.data,
            };
        case CALL_MONITORING:
            return {
                ...state,
                callMonitoringData: action.payload.data,
            };
        case PRINT_OPTION:
            return {
                ...state,
                isPrintOption: action.payload.data,
            };
        case UNSAVED_MODAL_CALL:
            return {
                ...state,
                isUnsavedOption: action.payload.data,
            };
        case ASSIGN_TECHNICIAN_MODAL:
            return {
                ...state,
                isTechnicianAssign: action.payload.data,
            };

        case CALL_SERVICES_OF_JOBS:
            return {
                ...state,
                isCallService: action.payload.data,
            };

        default:
            return state;
    }
}
